module.exports = __webpack_public_path__ + "static/media/staffi-business-lines.24484a8b.png";